import React from 'react';
import { EsignEmailProps } from '../types';

const ReScheduleEmail: React.FC<EsignEmailProps> = ({ clientName, firmName, projectName, sessionDate, sessionTime, sessionLink, shortCode }) => {
    return (
        <div style={{ width: '100%', backgroundColor: '#fff' }}>
            <div id="container" style={{ width: '40%', borderRadius: '10px', border: '1px solid #ececec' }}>
                <div style={{ width: '100%', padding: '30px' }}>
                    <img
                        style={{ width: '150px', marginBottom: '20px', marginLeft: '0px' }}
                        src="https://live.staticflickr.com/65535/54505029957_43c800fe19_z.jpg"
                        alt="LDD Connect"
                    />
                    <div style={{ fontFamily: 'Helvetica', fontSize: '12pt', color: '#686868', width: '80%' }}>
                        Hi {clientName},
                        <p></p>
                        Your lawyer from <b>{firmName}</b> has rescheduled your upcoming LDD eSignConnect remote eSigning session for your purchase in {projectName}.
                    </div>
                    <p></p>
                </div>

                <div style={{ padding: '30px', backgroundColor: '#f1f1f1' }}>
                    <table style={{ fontFamily: 'Helvetica', fontSize: '14pt', color: '#686868', width: '100%', backgroundColor: '#f1f1f1' }}>
                        <thead>
                            <tr>
                                <td style={{ width: '50%' }}><b>New Date</b></td>
                                <td><b>New Time</b></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{sessionDate}</td>
                                <td>{sessionTime}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ fontFamily: 'Helvetica', fontSize: '10pt', color: '#686868', width: '80%', fontStyle: 'italic', marginTop: '10px' }}>
                        Time listed in EST (New York).
                    </div>
                </div>

                <div style={{ width: '100%', padding: '30px' }}>
                    <div style={{ fontFamily: 'Helvetica', fontSize: '12pt', color: '#686868', width: '80%' }}>
                        Multiple people may join one session from the same device, or through separate devices using the same link.
                    </div>
                    <div style={{ fontFamily: 'Helvetica', fontSize: '12pt', color: '#686868', width: '80%', marginTop: '10px' }}>
                        <strong>Note:</strong> LDD eSigning isn't currently supported on mobile phones. You'll need to join the session from a desktop or laptop computer with camera and microphone access to be able to complete the signing process.
                    </div>
                    <p></p>
                    <a href={sessionLink} target="_blank" style={{ textDecoration: 'none' }}>
                        <div style={{ fontFamily: 'Helvetica', fontSize: '12pt', color: '#fff', backgroundColor: '#007AA9', borderRadius: '10px', padding: '15px', textAlign: 'center', width: '170px' }}>
                            Join Session
                        </div>
                    </a>
                </div>
            </div>
            <br />

            <div style={{ fontFamily: 'Helvetica', fontSize: '9pt', color: '#686868' }}>-- OR --</div>
            <br />
            <a href={sessionLink} style={{ fontFamily: 'Helvetica', fontSize: '9pt', color: '#686868', textDecoration: 'none' }}>{sessionLink}</a>
            <p />

            <div id="container" style={{ width: '40%', borderRadius: '10px', border: '1px solid #ececec' }}>
                <div style={{ width: '100%', padding: '30px' }}>
                    <div style={{ fontFamily: 'Helvetica', fontSize: '9pt', color: '#686868', width: '80%' }}>
                        LDD eSignConnect is a product of LawyerDoneDeal Corp. based out of Toronto, Ontario with operations across Canada.
                        <p></p>
                        <a href="https://ldd.ca/privacy/" target="_blank" style={{ textDecoration: 'underline', fontFamily: 'Helvetica', color: '#686868' }}>
                            View LDD's Privacy Policy.
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ReScheduleEmail;